/**
 * External dependencies.
 */
import React from "react";
import { useRouter } from "next/router";

/**
 * Internal dependencies.
 */
import Link from "components/link/link";

interface BreadcrumbsProp {
  omitIndexList?: number[];
  transformLabel?: (value: string) => string;
}

const Breadcrumbs: React.FC<BreadcrumbsProp> = ({
  omitIndexList,
  transformLabel,
}) => {
  const router = useRouter();
  const handleTitle = (value: string) => {
    if (transformLabel) {
      return transformLabel(value.replace("-", " "));
    }
    if (value.includes("?")) {
      value = value.split("?")[0];
    }
    return value.replace("-", " ");
  };

  const createLinks = () => {
    let stringArr = router.asPath.split("/").filter((item) => item);

    if (omitIndexList) {
      stringArr = stringArr.filter(
        (_, index) => omitIndexList.indexOf(index) === -1
      );
    }

    const handleLink = (index: number) =>
      "/" + stringArr.filter((str, ind) => ind <= index).join("/");
    return stringArr.map((item, index) =>
      stringArr.length > index + 1 ? (
        <Link key={index} href={handleLink(index)}>
          {handleTitle(item)}
        </Link>
      ) : (
        <span>{handleTitle(item)}</span>
      )
    );
  };

  return (
    <div className="breadcrumbs">
      <ul>
        <li>
          <Link href={"/"}>DigiFist</Link>
        </li>
        {createLinks().map((item, ind) => (
          <li key={ind}>{item}</li>
        ))}
      </ul>
    </div>
  );
};

export default Breadcrumbs;
